import { render, staticRenderFns } from "./PopTextArea.vue?vue&type=template&id=578a0091&scoped=true&"
import script from "./PopTextArea.vue?vue&type=script&lang=ts&"
export * from "./PopTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./PopTextArea.vue?vue&type=style&index=0&id=578a0091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a0091",
  null
  
)

export default component.exports